import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';

const VenueBlockedDatesSingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <Panel
                    heading={"Blocked Date Details"}
                >

                    <MetaTable
                        data={data}
                        columnA={[
                            {
                                label: "Date",
                                key: "date",
                                format: "Date",
                            },
                            {
                                label: "Start Time",
                                key: "startTime",
                            },
                            {
                                label: "End Time",
                                key: "endTime",
                            }
                        ]}
                        columnB={[
                            {
                                label: "Host",
                                key: "host",
                                format: "ModelLink",
                            },
                            {
                                label: "Court",
                                key: "courts",
                                format: "ModelLink",
                            }

                        ]}
                        columnC={[
                            {
                                label: "Created",
                                key: "created",
                                format: "OnAndBy",
                            },
                        ]}
                    />

                </Panel>

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default VenueBlockedDatesSingleView;
